<template>
  <div class="w-100" v-if="item">
    <div class="customized-title">
      <h4>{{ _T_DB(item, 'name') }}</h4>
      <button
        type="button"
        class="close"
        data-dismiss="modal"
        aria-label="Close"
        @click="close()"
      >
        <svg fill="none">
          <use xlink:href="#close-icon" />
        </svg>
      </button>
    </div>
    <div class="customized-price">
      <h6>{{ _T('price') }}</h6>
      <h4>
        <!--Num.price(discounted_menu_price(item) * qty || item.value * qty, item.original_value * qty)-->
        {{ currency }}
        {{ Num.price(discounted_menu_price(item) * qty || item.value * qty) }}
        <span v-if="selected_modifiers_price">
          + {{ currency }}
          {{
            Num.price(
              discounted_modifiers_price(item, selected_modifiers_price) *
                qty || selected_modifiers_price * qty
            )
          }}
          <span>({{ _T('additional') }})</span>
        </span>
      </h4>
    </div>
    <!--<router-link
        class=""
        :to="{
          name: brandStoreRoute('store_page'),
          params: {
            ...brandStoreParams,
          },
        }"
    >{{ _T('Visit to') }} {{ _T_DB(currentStore, 'name') }} {{ _T('Store') }}</router-link
    >-->
    <div class="customized-description">
      <h6 data-toggle="collapse" v-b-toggle.collapse-1>
        {{ _T('DESCRIPTION') }}
      </h6>
      <!--<b-collapse id="collapse-1" class="mt-2">-->
      <p>
        {{ item.description ? _T_DB(item, 'description') : 'N/A' }}
      </p>
      <!--    </b-collapse>-->
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'ItemInfo',
  computed: {
    ...mapGetters([
      'selected_modifiers_price',
      'hasModifiers',
      '_T',
      '_T_DB',
      'discounted_menu_price',
      'discounted_modifiers_price',
      'brandStoreRoute',
      'brandStoreParams',
      'currentStore',
    ]),
    ...mapState({
      openPopup: state => state.brand_store.openModifier,
      item: state => state.cart_store.selectedItem,
      qty: state => state.cart_store.qty,
    }),
  },
  methods: {
    close() {
      this.$store.commit('SET_ITEM_DETAIL_POPUP')
      document.body.classList.remove('body-overlay')
    },
  },
}
</script>

<style lang="scss" scoped>
.body-rtl {
  .customized-description {
    text-align: right;
  }
}
.customized-title {
  margin-bottom: $px24;
  display: flex;
  h4 {
    font-size: $px18;
    line-height: $px22;
    letter-spacing: 0.7px;
    color: $font-color;
    font-weight: bold;
    text-transform: capitalize;
    margin-bottom: 0;
  }
  .close {
    position: absolute;
    top: $px8;
    right: $px18;
    background-color: $white;
    opacity: 1;
    border-radius: 100%;
    padding: $px3;
    svg {
      width: $px25;
      height: $px25;
    }
  }
}
.customized-price {
  padding-bottom: $px16;
  border-bottom: $px1 solid $light-border;
  h6 {
    text-transform: capitalize;
    font-size: $px14;
    line-height: 160%;
    letter-spacing: 0.5px;
    color: $font-color;
    margin-bottom: 0;
  }
  h4 {
    font-weight: normal;
    font-size: $px18;
    line-height: $px22;
    text-transform: uppercase;
    color: $color-primary;
    margin-bottom: 0;
    span {
      color: $light-font;
      text-transform: capitalize;
    }
  }
}
.customized-description {
  padding-top: $px14;
  padding-bottom: $px14;
  border-bottom: $px1 solid $light-border;
  h6 {
    font-style: normal;
    font-weight: 600;
    font-size: $px12;
    line-height: $px15;
    letter-spacing: 0.5px;
    color: $font-color;
    text-transform: uppercase;
    margin-bottom: 0;
    position: relative;
    cursor: pointer;
    /*&:after {
      content: '';
      position: absolute;
      font-weight: 900;
      width: $px18;
      height: $px18;
      right: 0;
      top: 0;
      opacity: 1;
      background-image: url('/images/svg/global/arrow-down.svg');
      transition: transform 0.4s cubic-bezier(0.45, 1.8, 0.5, 0.75),
        -webkit-transform 0.4s cubic-bezier(0.45, 1.8, 0.5, 0.75);
      transform: rotate(0) scale(1, 1);
      background-repeat: no-repeat;
    }
    &.collapsed {
      &:after {
        background-image: url('/images/svg/global/controller.svg');
      }
    }*/
  }
  p {
    font-weight: normal;
    font-size: $px12;
    line-height: $px19;
    color: $font-color;
    margin-top: $px8;
    margin-bottom: 0;
    letter-spacing: 0.01px;
  }
}
</style>
